/**
 * Input validation: Errors block calculation, Warnings allow calculation with yellow alert.
 */
export type ValidationStatus = 'valid' | 'warning' | 'error';

export interface ValidationResult {
  status: ValidationStatus;
  message?: string;
}

export function validateSystolicBp(value: number): ValidationResult {
  if (value < 40) return { status: 'error', message: 'Çok Düşük Kan Basıncı, Yeniden Ölçünüz' };
  if (value >= 40 && value <= 79)
    return { status: 'warning', message: 'Çok Düşük Kan Basıncı, Lütfen Kontrol Edin' };
  if (value >= 201 && value <= 300)
    return { status: 'warning', message: 'Çok Yüksek Kan Basıncı, Yeniden Kontrol Edin' };
  if (value > 300) return { status: 'error', message: 'Çok Yüksek Kan Basıncı, Yeniden Ölçün' };
  return { status: 'valid' };
}

export function validateTotalCholesterol(value: number): ValidationResult {
  if (value < 50) return { status: 'error', message: 'Toplam kolesterol çok düşük (min 50 mg/dL)' };
  if (value > 1000) return { status: 'error', message: 'Toplam kolesterol çok yüksek (max 1000 mg/dL)' };
  if (value >= 401 && value <= 1000)
    return { status: 'warning', message: 'Toplam kolesterol yüksek, lütfen kontrol edin' };
  return { status: 'valid' };
}

export function validateHdlCholesterol(value: number): ValidationResult {
  if (value < 10) return { status: 'error', message: 'HDL kolesterol çok düşük (min 10 mg/dL)' };
  if (value > 120) return { status: 'error', message: 'HDL kolesterol çok yüksek (max 120 mg/dL)' };
  if (value >= 91 && value <= 120)
    return { status: 'warning', message: 'HDL kolesterol yüksek, lütfen kontrol edin' };
  return { status: 'valid' };
}

/** Non-HDL must be positive (Total - HDL > 0) for calculation */
export function validateNonHdl(total: number, hdl: number): ValidationResult {
  const nonHdl = total - hdl;
  if (nonHdl < 0)
    return { status: 'error', message: 'Non-HDL (Toplam - HDL) negatif olamaz. HDL, Toplam değerinden küçük olmalıdır.' };
  return { status: 'valid' };
}

/** Returns true if any validation is error (calculation disabled) */
export function hasBlockingError(
  sbp: ValidationResult,
  totalChol: ValidationResult,
  hdl: ValidationResult,
  nonHdl: ValidationResult
): boolean {
  return sbp.status === 'error' || totalChol.status === 'error' || hdl.status === 'error' || nonHdl.status === 'error';
}

/** Returns true if any validation is warning (show yellow alert but allow calculation) */
export function hasWarning(
  sbp: ValidationResult,
  totalChol: ValidationResult,
  hdl: ValidationResult
): boolean {
  return sbp.status === 'warning' || totalChol.status === 'warning' || hdl.status === 'warning';
}
